<template>
  <tr class="change-status__shareclass mds-data-table__row">
    <td class="mds-data-table__cell">
      <div v-if="isPending" class="pending-icon mds-icon">
        <svg class="mds-icon" aria-hidden="true">
          <use
            xmlns:xlink="http://www.w3.org/1999/xlink"
            xlink:href="static/mds/icons/mds.svg#clock-back"
          ></use>
        </svg>
      </div>
    </td>
    <td class="mds-data-table__cell" scope="row" :colspan="haveClients ? 2 : 1">
      <slot></slot>
    </td>
    <td class="mds-data-table__cell">
      {{ ticker }}
    </td>
    <td class="mds-data-table__cell mds-data-table__cell--left">
      <status-icons :status="statusArray" />
      {{ statusText }}
    </td>
    <td class="mds-data-table__cell mds-data-table__cell--left">
      <status-icons v-if="newStatus" :status="[{ name: newStatusIcon }]" />
      <div v-else class="status-icons"></div>
      <div class="mds-form__select">
        <select
          class="mds-form__select-input change-status__select--share-class"
          :id="`change-status__select--share-class-${fundId}`"
          :value="newStatus"
          @change="onSelect"
          :disabled="areFundSeries"
        >
          <option
            v-for="option in options"
            class="mds-form__select-option"
            :value="option.value"
            :disabled="option.config.disabled"
            :key="option.value"
          >
            {{ option.label }}
          </option>
        </select>
        <div class="mds-form__select-visual-wrap"></div>
        <span class="mds-form__select-open-indicator">
          <svg class="mds-icon mds-form__select-open-icon" aria-hidden="true">
            <use xlink:href="static/mds/icons/mds.svg#caret-down--s"></use>
          </svg>
        </span>
      </div>
    </td>
  </tr>
</template>
<script>
import { every } from 'lodash';
import StatusIcons from '@/components/atoms/StatusIcons';

export default {
  name: 'change-status-shareclass',
  components: {
    StatusIcons,
  },
  props: {
    statusArray: {
      type: Array,
      required: true,
      validator: (statuses) => {
        return Array.isArray(statuses) && statuses.length > 0 && every(statuses, (status) => status.name);
      },
    },
    statusText: {
      type: String,
      default: '',
    },
    fundId: {
      type: Number,
    },
    ticker: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    newStatus: {
      type: Number,
      default: 0,
    },
    newStatusIcon: {
      type: String,
      default: '',
    },
    newStatusText: {
      type: String,
      default: '',
    },
    haveClients: {
      type: Boolean,
      default: false,
    },
    areFundSeries: {
      type: Boolean,
      default: false,
    },
    isPending: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    onSelect(event) {
      this.$emit('onSelect', parseInt(event.target.value, 10));
    },
  },
};
</script>
<style lang="scss">
.change-status__shareclass {
  & div[class^="status-array"] {
    display: inline;
  }
  & .status-icons {
    margin-right: $mds-space-half-x;
  }
  & .mds-form__select {
    margin-top: -$mds-space-1-x;
  }
}
</style>
